<template>
  <section class="mt-n4 mb-1 pb-5">
    <p class="pull-right mb-2 small">
      <button
          class="btn btn-primary px-2 py-2 pt-0 pb-1"
          style="font-size: 1rem; font-weight: bold;"
          @click="$emit('next')"
          :disabled="processingApi || $v.$invalid"
      >
        <small> {{ $t('advance') }} </small>
      </button>
    </p>
    <p class="pull-right mr-2">
      <button
          class="btn btn-primary px-2 py-2 pt-0 pb-1"
          style="font-size: 1rem;"
          @click="$emit('prev')"
          :disabled="processingApi"
          v-show="activeStepIndex > 0"
      >
        <small> {{ $t('back') }} </small>
      </button>
    </p>
  </section>
</template>
<script>
export default {
  name: 'navigation',
  props: {
    processingApi: {},
    activeStepIndex: {},
    $v: {}
  }
}
</script>
